import "./About.css"
import logo from "../assets/logo.jpg"
import { useInView } from "framer-motion";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const About = ({ refProp }) => { // ref ismini refProp yapalım çakışmasın
    const isInView = useInView(refProp, { once: true, margin: "-50px" });
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <motion.footer
            ref={refProp}
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.8 }}
            className="footer-section"
        >
            <div className="footer-content">
                <div className="footer-column branding">
                    <img src={logo} alt="Güçlükaya Logo" className="footer-logo" />
                    <div className="footer-title">
                        <h2>GÜÇLÜKAYA</h2>
                        <h3>İNŞAAT</h3>
                    </div>
                </div>

                <div className="footer-column info">
                    <h4>İLETİŞİM</h4>
                    <p>Mebusevleri Mah. Turgut Reis Cad. No:3/4 Çankaya/ANKARA</p>
                    <a href="tel:+903122156036" className="footer-link">T: +90 312 215 60 36</a>
                    <a href="mailto:info@guclukayainsaat.com" className="footer-link">E: info@guclukayainsaat.com</a>
                </div>

                <div className="footer-column career">
                    <h4>KARİYER</h4>
                    <p>Daha iyi bir gelecek için ekibimize katılmak isterseniz özgeçmişinizi paylaşabilirsiniz.</p>
                    <a href="mailto:info@guclukayainsaat.com" className="career-btn">Bize Ulaşın</a>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© 2026 TÜM HAKLARI GÜÇLÜKAYA İNŞAAT'A AİTTİR.</p>
            </div>
        </motion.footer>
    );
}

export default About;